import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from 'ionic-angular';

import { EventCardComponent } from './event-card/event-card';
import { PipesModule } from '../pipes/pipes.module';
import { CategoriesCardComponent } from './categories-card/categories-card';


let components = [
	EventCardComponent,
	CategoriesCardComponent
]

@NgModule({
	declarations: components,
	imports: [
		PipesModule,
		CommonModule,
		IonicModule
	],
	exports: components
})
export class ComponentsModule {}



// WEBPACK FOOTER //
// ./src/components/components.module.ts